import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { AlertService } from './alert.service';

@Injectable()
export class AuthenticationService {
  hostUrl: any = environment.API_BASE_URL;
  urlToLogin: any = this.hostUrl + 'api/signin';
  constructor(private http: Http) {}
  // login(email: string, password: string) {
  // 	return this.http.post('', JSON.stringify({email: email, password: password}))
  // 		.map((response: Response) => {
  // 			// login successful if there's a jwt token in the response
  // 			let user = response.json();
  // 			if (user && user.token) {
  // 				// store user details and jwt token in local storage to keep user logged in between page refreshes
  // 				localStorage.setItem('CURRENT_USER', JSON.stringify(user));
  // 			}
  // 		});
  // }

  login(email: string, password: string) {
    return this.http
      .post(this.urlToLogin, JSON.stringify({ email: email, password: password }), {
        headers: new Headers({ 'Content-Type': 'application/json' })
      })
      .map((response: Response) => response);
  }

  logout() {
    localStorage.clear(); // to remove CURRENT_USER as well as all API_RESPONSE_*
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/_services/authentication.service.ts